export const Characteristics = [
    { "name": "-", "value": "0"},
    { "name": "Wyprzedaż", "value": "1"},
    { "name": "Tachografy Analogowe-1311-1314", "value": "2"},
    { "name": "Tachografy Analogowe-1318", "value": "3"},
    { "name": "Tachografy Analogowe-1319", "value": "4"},
    { "name": "Tachografy Analogowe-1324","value": "5" },
    { "name": "Tachografy Analogowe-Pozostałe","value": "6"},
    { "name": "Tachografy Cyfrowe-VDO 3.0","value": "7"},
    { "name": "Tachografy Cyfrowe-VDO 4.0", "value": "8"},
    { "name": "Tachografy Cyfrowe-SE5000,EFAS", "value": "9"},
    { "name": "Tachografy -Pozostałe", "value": "10"},
    { "name": "Tachografy -Używane", "value": "11"},
    { "name": "Tachografy Przetworniki-HALLOTRONOWE", "value": "12"},
    { "name": "Tachografy Przetworniki-INDUKCYJNE", "value": "13"},
    { "name": "Tachografy Przetworniki-KITAS", "value": "14"},
    { "name": "Tachografy Przetworniki-ADAPTER", "value": "15"},
    { "name": "Tachografy -Przewody", "value": "16"},
    { "name": "Tachografy -Prędkościomierze", "value": "17"},
    { "name": "Tachografy -Termopapier", "value": "18"},
    { "name": "Tachografy -Wykresówki", "value": "19"},
    { "name": "Tachografy -Akcesoria", "value": "20"},
    { "name": "UrządzeniaKontrolne-Pobieranie danych", "value": "21"},
    { "name": "UrządzeniaKontrolne-WORKSHOPTAB", "value": "22"},
    { "name": "UrządzeniaKontrolne-TT2010", "value": "23"},
    { "name": "Wentylatory i dmuchawy -Dmuchawy 12V", "value": "24"},
    { "name": "Wentylatory i dmuchawy -Dmuchawy 24V", "value": "25"},
    { "name": "Wentylatory i dmuchawy -Wentylatory 12V", "value": "26"},
    { "name": "Wentylatory i dmuchawy -Wentylatory 24V", "value": "27"},
    { "name": "Wentylatory i dmuchawy -Akcesoria", "value": "28"},
    { "name": "Ogrzewania postojowe -EBERSPACHER", "value": "29"},
    { "name": "Ogrzewania postojowe -WEBASTO", "value": "30"},
    { "name": "Ogrzewania postojowe -PozostałeOgrzewania", "value": "31"},
    { "name": "TRUCK AkcesoriaTruck-Narzędzia", "value": "32"},
    { "name": "TRUCK AkcesoriaTruck-Zabezpieczenia", "value": "33"},
    { "name": "TRUCK AkcesoriaTruck-Dywaniki", "value": "34"},
    { "name": "TRUCK AkcesoriaTruck-Pistolety", "value": "35"},
    { "name": "TRUCK AkcesoriaTruck-Przewody elektryczne", "value": "36"},
    { "name": "TRUCK AkcesoriaTruck-Przewody spiralne", "value": "37"},
    { "name": "TRUCK AkcesoriaTruck-Pozostałe Akcesoria", "value": "38"},
    { "name": "TRUCK ZabezpieczenieŁadunku-Pasy", "value": "39"},
    { "name": "TRUCK ZabezpieczenieŁadunku-Drążki", "value": "40"},
    { "name": "TRUCK ZabezpieczenieŁadunku-Belki", "value": "41"},
    { "name": "TRUCK ZabezpieczenieŁadunku-Ochraniacze i maty", "value": "42"},
    { "name": "TRUCK ZabezpieczenieŁadunku-Siatki", "value": "43"},
    { "name": "TRUCK -Zawiesia pasowe", "value": "44"},
    { "name": "TRUCK -Windy", "value": "45"},
    { "name": "TRUCK -CB radio", "value": "46"},
    { "name": "TRUCK -Pozostałe", "value": "47"}
]
export const MaterialGroup = [
    { "name": "-", "value": "0"},
    { "name": "Przeprawy promowe", "value": "101"},
    { "name": "Tachografy", "value": "103"},
    { "name": "Koła", "value": "104"},
    { "name": "Wentylatory i dmuchawy", "value": "105"},
    { "name": "BHP","value": "106" },
    { "name": "VDO Instrumenty","value": "107"},
    { "name": "Ogrzewania postojowe","value": "108"},
    { "name": "Ograniczniki prędkości", "value": "109"},
    { "name": "TRUCK", "value": "110"},
    { "name": "e-TOLL", "value": "119"}
]
export const StatusCarrier = [
    { "name": "W drodze", "value": "I"},
    { "name": "Dostarczona", "value": "D"},
    { "name": "Wyjątek", "value": "X"},
    { "name": "Odebrana przez sped.", "value": "P"},
    { "name": "Wygenerowana etyk.", "value": "M"},
    { "name": "Błąd", "value": "E"},
]